var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.047,
    height: 16.047,
    viewBox: "0 0 16.047 16.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1101",
    d: "M0-682.665H16.047v16.047H0Z",
    transform: "translate(0 682.665)",
    fill: "#583d8b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1095",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1097",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1099",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1105",
    transform: "translate(0.627 0.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    d: "M14.793-207.818a.5.5,0,0,1-.291-.094L7.826-212.7a.745.745,0,0,0-.429-.134.748.748,0,0,0-.433.137L.291-207.912a.5.5,0,0,1-.7-.115.5.5,0,0,1,.115-.7l6.676-4.787a1.746,1.746,0,0,1,1.012-.321,1.743,1.743,0,0,1,1.009.319l6.68,4.79a.5.5,0,0,1,.115.7A.5.5,0,0,1,14.793-207.818Z",
    transform: "translate(0 213.333)",
    fill: "#d85863"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1109",
    transform: "translate(1.881 3.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1111",
    d: "M-285.851-10.188a1.743,1.743,0,0,1,1.009.319l0,0,4.888,3.529a1.756,1.756,0,0,1,.741,1.432V.718a1.756,1.756,0,0,1-1.754,1.754H-284.6a.5.5,0,0,1-.5-.5V-.536a.755.755,0,0,0-.754-.754.755.755,0,0,0-.754.754V1.971a.5.5,0,0,1-.5.5h-3.636A1.756,1.756,0,0,1-292.494.718V-4.9a1.756,1.756,0,0,1,.742-1.432l4.888-3.529,0,0A1.743,1.743,0,0,1-285.851-10.188Zm.431,1.135a.748.748,0,0,0-.431-.135.748.748,0,0,0-.431.135l-4.888,3.528,0,0a.755.755,0,0,0-.32.616V.718a.755.755,0,0,0,.754.754h3.136V-.536a1.756,1.756,0,0,1,1.754-1.754A1.756,1.756,0,0,1-284.1-.536V1.471h3.136a.755.755,0,0,0,.754-.754V-4.9a.755.755,0,0,0-.32-.616l0,0Z",
    transform: "translate(291.994 9.688)",
    fill: "#d85863"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.f2229c96ee560517216a6c75718b5a9c.svg";
export { ForwardRef as ReactComponent };